export default {
  'app.pwa.offline': 'Du er frakoblet nå',
  'app.pwa.serviceworker.updated': 'Nytt innhold er tilgjengelig',
  'app.pwa.serviceworker.updated.hint': 'Trykk på "Oppdater" -knappen for å laste inn gjeldende side på nytt',
  'app.pwa.serviceworker.updated.ok': 'Forfriske',
};
